import {
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { DxPopupComponent } from 'devextreme-angular/ui/popup';

@Component({
  selector: '',
  template: `<dx-popup
    #dxPopUp
    [(visible)]="popupComponentVisible"
    [width]="attrWidth"
    [height]="attrHeight"
    class="windowOverlay"
    [hideOnOutsideClick]="hideOnOutsideClick"
    [maxHeight]="maxHeight"
    [minHeight]="minHeight"
    [maxWidth]="maxWidth"
    [minWidth]="minWidth"
    [dragEnabled]="dragEnabled"
    [position]="position"
    [resizeEnabled]="resizable"
    [fullScreen]="fullScreen"
    [shading]="shading"
    [animation]="null"
    [shadingColor]="shadingColor"
    (onResizeStart)="onResizeStart()"
    (onResizeEnd)="onResizeEnd()"
    (onShown)="afterOpened($event)"
    (onHidden)="afterClosed($event)"
    (onHiding)="onHiding($event)"
    (onResize)="onResize($event)"
    (onContentReady)="onContentReadyHandler($event)"
  >
    <div *dxTemplate="let data of 'title'" id="{{ attrId }}">
      <mat-icon *ngIf="attrlogo" class="iconStyle" svgIcon="{{ attrlogo }}"></mat-icon>
      <div>{{ label }}</div>
      <div class="optionsWindow" (click)="$event.stopPropagation()">
        <mat-icon *ngIf="minimizeButton" class="iconStyle" svgIcon="minimize" (click)="minumizeDialog()"></mat-icon>
        <mat-icon *ngIf="maximizeButton" class="iconStyle" svgIcon="maximize" (click)="maximizeDialog()"></mat-icon>
        <mat-icon *ngIf="restoreButton" class="iconStyle" svgIcon="restore" (click)="maximizeDialog()"> </mat-icon>
        <mat-icon class="iconStyle" svgIcon="close" (click)="closeClick()"> </mat-icon>
      </div>
    </div>
    <abcLoader id="loaderWindow" [class]="'window-loader'" *ngIf="showLoader" [show]="showLoader"></abcLoader>
    <ng-template #contentComponent></ng-template>
  </dx-popup>`,
  styleUrls: ['./devExWindow.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class DevExWindowComponent implements OnDestroy {
  @ViewChild('dxPopUp', { static: true }) dxWindow: DxPopupComponent;
  @ViewChild('contentComponent', { static: true, read: ViewContainerRef }) contentComponent: ViewContainerRef;
  @Input() hideOnOutsideClick: boolean;
  @Input() maxWidth: string | number;
  @Input() maxHeight: string | number;
  @Input() minWidth: string | number;
  @Input() minHeight: string | number;
  @Input() attrWidth: string;
  @Input() attrHeight: string;
  @Input() resizable: string;
  @Input() maximizeButton: boolean;
  @Input() minimizeButton: boolean;
  @Input() attrlogo: any;
  @Input() attrComponent: any;
  @Input() attrReqData: any;
  @Input() attrId: string;
  @Input() showLoader: boolean;
  @Input() shading: boolean;
  @Input() shadingColor: string;
  @Input() minumizeDialogOption: number;
  @Input() component;
  @Input() position: string | object;
  @Input() isInMobile: boolean;
  @Input() storeState: boolean;
  @Output() onAfterOpened = new EventEmitter();
  @Output() onAfterClosed = new EventEmitter();
  @Output() onCloseClick = new EventEmitter();
  @Output() onClosing = new EventEmitter();
  @Output() onContentReady = new EventEmitter();
  public popupComponentVisible = false;
  public restoreButton: boolean;
  private attrLabel: string;
  private prevWidth: number;
  private prevHeight: number;
  public fullScreen: boolean;
  private prevOffset: object;
  public dragEnabled: boolean;
  private enableFullscreenMode: boolean;
  private sizeParameter: SizeParameter;
  private positionParameter: PositionParameter;
  private storeStateKey: string;
  get label(): string {
    return this.attrLabel;
  }
  set label(label: string) {
    this.attrLabel = label;
  }
  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange(): void {
    if (this.isInMobile) {
      this.repaint();
    }
  }
  constructor(private componentFactoryResolver: ComponentFactoryResolver, private cdr: ChangeDetectorRef) {
    this.dragEnabled = true;
    this.fullScreen = false;
  }

  ngOnDestroy(): void {
    this.contentComponent.remove();
    this.dxWindow.ngOnDestroy();
  }
  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  public onContentReadyHandler(ev) {
    this.sizeParameter = { width: this.attrWidth, height: this.attrHeight };
    this.onContentReady.next(ev);
  }

  public onResize(ev) {
    this.prevWidth = ev.width;
    this.prevHeight = ev.height;
  }

  public onResizeStart() {
    this.dxWindow.instance.option('minHeight', '0');
  }

  public onResizeEnd() {
    this.sizeParameter = { width: this.prevWidth, height: this.prevHeight };
  }

  public afterOpened(ev) {
    this.onAfterOpened.next(ev);
  }

  public afterClosed(ev) {
    this.onAfterClosed.next(ev);
  }

  public openWindow(): ComponentRef<unknown> {
    this.popupComponentVisible = true;
    const factory = this.componentFactoryResolver.resolveComponentFactory(this.component);
    const componentRef = this.contentComponent.createComponent(factory);
    return componentRef;
  }

  public onHiding(event) {
    this.onClosing.emit(event);
    if (this.storeState) {
      this.positionParameter = { my: 'top left', at: 'top left', offset: this.getWindowOffset() };
      this.storeWindowState([this.positionParameter, this.sizeParameter]);
    }
  }

  private storeWindowState(item): void {
    const items = [];
    for (let i = 0; i < item.length; i++) {
      items.push(item[i]);
    }
    localStorage.setItem(this.storeStateKey, JSON.stringify(items));
  }
  public closeDialog(): void {
    this.popupComponentVisible = false;
  }

  public closeClick(): void {
    this.onCloseClick.emit();
  }

  public maximizeDialog(): void {
    if (this.minimizeButton == true && this.fullScreen == false) {
      this.fullScreen = true;
      this.dxWindow.instance.option('maxHeight', 'none');
      this.restoreButton = true;
      this.maximizeButton = false;
      this.prevOffset = this.getWindowOffset();
      this.sizeParameter = { width: '100%', height: '100%' };
    } else {
      this.fullScreen = false;
      this.restoreButton = false;
      this.maximizeButton = true;
      this.dragEnabled = true;
      this.dxWindow.instance.option('maxHeight', this.maxHeight);
      if (this.prevWidth || this.prevHeight) {
        this.dxWindow.instance.option({ width: this.prevWidth, height: this.prevHeight });
        this.sizeParameter = { width: this.prevWidth, height: this.prevHeight };
      } else {
        this.dxWindow.instance.option({ width: this.attrWidth, height: this.attrHeight });
        this.sizeParameter = { width: this.attrWidth, height: this.attrHeight };
      }
      if (this.enableFullscreenMode == true) {
        this.fullScreen = true;
        this.restoreButton = true;
        this.maximizeButton = false;
        this.enableFullscreenMode = false;
        this.dxWindow.instance.option('maxHeight', 'none');
      }
      if (this.storeState) {
        this.dxWindow.instance.option('position', { my: 'left top', at: 'left top', offset: this.prevOffset });
      } else {
        this.dxWindow.instance.option('position', { my: 'center', at: 'center', offset: '0 0' });
      }
    }
    this.minimizeButton = true;
  }

  public minumizeDialog(): void {
    if (this.fullScreen == false) {
      this.prevOffset = this.getWindowOffset();
    } else {
      this.enableFullscreenMode = true;
    }
    this.fullScreen = false;
    this.minimizeButton = false;
    this.restoreButton = false;
    this.maximizeButton = true;
    this.dragEnabled = false;
    this.dxWindow.instance.option('minHeight', '0');
    this.dxWindow.instance.option('maxWidth', '600');
    this.dxWindow.instance.option({
      width: '100%',
      height: '33',
      position: { my: 'left bottom', at: 'left bottom', offset: '"0' + ' ' + this.minumizeDialogOption + '"' },
    });
  }

  private getWindowOffset(): object {
    const element = document.querySelector('#' + this.attrId).parentElement;
    const style = window.getComputedStyle(element);
    const matrix = new WebKitCSSMatrix(style.transform);
    return { x: matrix.m41, y: matrix.m42 };
  }

  private repaint(): void {
    this.dxWindow.instance.repaint();
  }
}

export interface SizeParameter {
  width: string | number;
  height: string | number;
}
export interface PositionParameter {
  my: string | number;
  at: string | number;
  offset: object;
}
